import { createFileRoute } from "@tanstack/react-router";

import { ForgeAutomationDetailPage } from "../components/automations/ForgeAutomationDetailPage";

export const Route = createFileRoute("/_chat/automations/$automationId")({
  component: AutomationDetailRoute,
});

function AutomationDetailRoute() {
  const { automationId } = Route.useParams();
  return <ForgeAutomationDetailPage automationId={automationId} />;
}
